

<template>
  <CContainer class="d-flex content-center min-vh-100">
    <CRow>
      <CCol>
        <CCardGroup>
          <CCard class="p-4">
            <CCardBody>
              <div v-if='isContractExpired'>
                <p class="errorLabel" v-if='expiredType == "after"'> 契約期限が切れました。お問い合わせください。</p>
                <p class="errorLabel" v-else> 契約開始前です。</p>
              </div>
              <CForm >
                <h1>ログイン</h1>
                <p class="text-muted">IDとパスワードを入力し、ログインしてください</p>
                <CInput
                  placeholder="E-mail"
                  autocomplete="username email"
                  v-model="username"
                >
                  <template #prepend-content><CIcon name="cil-user"/></template>
                </CInput>
                <CInput
                  placeholder="パスワード"
                  type="password"
                  autocomplete="curent-password"
                  v-model="password"
                  class="mt-2"
                >
                  <template #prepend-content><CIcon name="cil-lock-locked"/></template>
                </CInput>
                <CRow>
                  <CCol col="12" class="text-center">
                    <CButton @click="login" color="primary" class="px-4 mt-3">ログイン</CButton>
                  </CCol>
                </CRow>
              </CForm>
            </CCardBody>
          </CCard>
        </CCardGroup>
      </CCol>
    </CRow>
  </CContainer>

</template>

<script>
import firebase from 'firebase'
import { mapGetters } from 'vuex';
export default {
  name: 'Home',
  components: {},
  data() {
    return {
      username: '',
      password: '',
    }
  },
  methods: {
    login () {
      firebase.auth().signInWithEmailAndPassword(this.username, this.password)
        .then(() => {
          firebase.auth().currentUser.getIdToken(true)
          .then(function(idToken) {
            this.$store.commit('setIdToken', idToken)
            this.$store.dispatch('fetchParter', idToken)
          }).catch(function() {});

          this.$router.replace('dashboard')
        })
        .catch(error => {
          alert(error.message)
        })
      // this.$cognito.login(this.username, this.password)
      //   .then(result => {
      //     console.log(result)
      //     this.$router.replace('/industries')
      //   })
      //   .then(err => {
      //     console.log(err)
      //     this.error = err
      //   })
    },
  },
  computed: {
    ...mapGetters({
      isContractExpired:'GetIsContractExpired',
      expiredType:'GetExpiredType',
    })
  },

}
</script>
